import React from 'react'
import { ErrorDetailsRows } from '../alerts/StatusResponse'

function ErrorRow({ errros }: { errros: ErrorDetailsRows[] }) {
    return (
        <div style={{ width: '200px' }}>
            {errros
                .filter(({ status }) => status === 'ERROR')
                .map(eventInfo => {
                    const columnName = eventInfo?.columnName || ''
                    const type = eventInfo?.type || ''
                    const messages = eventInfo?.messages || []

                    return (
                        <span
                            style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}
                            key={'collumns-info'}
                        >
                            <span>
                                <h4>
                                    {columnName} ({type})
                                </h4>
                            </span>
                            <span
                                style={{
                                    display: messages.length > 0 ? 'auto' : 'none'
                                }}
                            >
                                <b>Erros:</b>
                                <ul key={'msg'}>
                                    {messages.map((msg, expectIndex) => (
                                        <li key={`msg-row-${expectIndex}`}>{msg}</li>
                                    ))}
                                </ul>
                            </span>
                        </span>
                    )
                })}
        </div>
    )
}
function ErrorRowHeader() {
    return (
        <div style={{ textAlign: 'center' }}>
            <i className="far fa-exclamation-triangle" style={{ color: 'var(--yellow-700)' }}></i>{' '}
            <b style={{ color: 'var(--yellow-700)' }}>File does not Match the Template Settings</b>{' '}
        </div>
    )
}

export { ErrorRow, ErrorRowHeader }
